var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outline/paper_upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41699 15.5338C6.41699 8.97728 12.2255 4.0835 18.5374 4.0835H34.5058C35.2757 4.0835 36.0144 4.38791 36.5608 4.93035L48.7219 17.0042C49.2735 17.5518 49.5837 18.2969 49.5837 19.074V40.1049C49.5837 46.406 44.2928 51.9168 37.7129 51.9168H18.5374C11.7824 51.9168 6.41699 46.7738 6.41699 40.1049V15.5338ZM18.5374 9.91683C14.9638 9.91683 12.2503 12.6619 12.2503 15.5338V40.1049C12.2503 43.3954 14.8451 46.0835 18.5374 46.0835H37.7129C41.0234 46.0835 43.7503 43.2323 43.7503 40.1049V20.2883L33.3038 9.91683H18.5374ZM26.5779 40.866C24.9671 40.866 23.6612 39.5601 23.6612 37.9493L23.6612 29.6756L22.0215 31.3223C20.8848 32.4637 19.0381 32.4676 17.8967 31.331C16.7552 30.1944 16.7514 28.3476 17.888 27.2062L24.4714 20.595C24.9309 20.1152 25.5528 19.7921 26.2488 19.714C26.358 19.7016 26.4683 19.6952 26.5793 19.6952C26.8075 19.6953 27.033 19.722 27.2515 19.7738C27.3803 19.8043 27.5058 19.8432 27.6273 19.8901C28.0062 20.0361 28.3542 20.2609 28.6462 20.5542L35.2682 27.2066C36.4046 28.3482 36.4004 30.1949 35.2587 31.3313C34.1171 32.4678 32.2704 32.4635 31.134 31.3219L29.4946 29.675L29.4945 37.9493C29.4945 39.5601 28.1887 40.866 26.5779 40.866Z",
    fill: "#7E9EBC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line",
    d: "M32.667 7V14.4229C32.667 18.0464 35.689 20.9861 39.4237 20.9937C42.8849 21.0014 46.4277 21.0039 46.667 20.9886",
    stroke: "#7E9EBC",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperUpload);
export default __webpack_public_path__ + "static/media/paper_upload.a34a1d1b31868e30ade4f19bb57a2370.svg";
export { ForwardRef as ReactComponent };